/**
 * Non-react access to query parameters. This is outside of the history
 * object of the app, and would not, for example cause re-render on changes
 */
export const getQueryParams = () => {
  const locationParams = new URLSearchParams(window.location.search);

  return locationParams;
};

export const noop = () => {};

export const noopAsync = async () => {};
